import { Link } from 'react-router-dom';
import TopicCard from '@/components/feature/TopicCard';
import { topics } from '@/mocks/topics';

export default function FeaturedTopics() {
  const featured = topics.slice(0, 5);

  return (
    <section id="featured" className="px-4 md:px-10 py-16 md:py-20" aria-label="精选专题合集">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <span className="text-xs tracking-[0.3em] text-primary-600 font-medium">FEATURED COLLECTIONS</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">本周精选专题合集</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl leading-relaxed">
            编辑按更新时间与完读率挑出的五组合集，每一组都把同一类话题收拢在一起，方便一次看完。
          </p>
        </div>
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
        >
          全部 {topics.length} 个专题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {featured.map((topic, idx) => (
          <TopicCard key={topic.id} topic={topic} index={idx} />
        ))}
      </div>
    </section>
  );
}